import React from 'react';
import FreeDownloads from '../../../components/others/FreeDownloads';
import Preloader from '../../../components/common/Preloader';
import MetaComponent from '../../../components/common/MetaComponent';

const metadata = {
  title: "Free Downloads || GVK Student Portal",
  description: "Access our collection of free educational resources, study materials, and reference documents. Download instantly - no registration required.",
};

const FreeDownloadsPage = () => {
  return (
    <>
      <MetaComponent meta={metadata} />
      <Preloader />
      <FreeDownloads />
    </>
  );
};

export default FreeDownloadsPage;
